import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="w-full px-4 md:px-6 lg:px-10 py-20 md:py-28 flex flex-col items-center justify-center text-center">
      <h1 className="font-heading text-7xl md:text-9xl font-black text-background-200 select-none leading-none">404</h1>
      <div className="relative -mt-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">这个页面走丢了</h2>
        <p className="mt-2 text-sm text-foreground-500 font-mono break-all">{location.pathname}</p>
        <p className="mt-3 text-sm md:text-base text-foreground-600">
          你要找的内容可能已被移除，或者链接输入有误。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-3 mt-7">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-5-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-sm font-medium text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-layout-grid-line"></i>
            浏览电视剧分类
          </Link>
        </div>
      </div>
    </div>
  );
}